export const pageFetchMainURL = "https://www.polishgranite.co.uk";
